import { ChangeDetectionStrategy, Component, input } from '@angular/core';

type SpinnerSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-loading-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'size()',
    'role': 'status',
    '[attr.aria-label]': 'label()',
  },
  template: `
    <svg viewBox="0 0 24 24" fill="none" class="spinner">
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        class="track" />
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-dasharray="60 200"
        class="indicator" />
    </svg>
  `,
  styles: `
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    :host.sm { width: 1rem; height: 1rem; }
    :host.md { width: 1.5rem; height: 1.5rem; }
    :host.lg { width: 2.5rem; height: 2.5rem; }

    .spinner {
      width: 100%;
      height: 100%;
      animation: rotate 1.4s linear infinite;
    }

    .track {
      opacity: 0.2;
    }

    .indicator {
      animation: dash 1.4s ease-in-out infinite;
    }

    @keyframes rotate {
      100% { transform: rotate(360deg); }
    }

    @keyframes dash {
      0% {
        stroke-dasharray: 1 200;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 60 200;
        stroke-dashoffset: -35;
      }
      100% {
        stroke-dasharray: 60 200;
        stroke-dashoffset: -125;
      }
    }
  `,
})
export class LoadingSpinnerComponent {
  readonly size = input<SpinnerSize>('md');
  readonly label = input('Loading');
}
